import { zodResolver } from '@hookform/resolvers/zod';
import { Resolver, UseFormProps } from 'react-hook-form';
import { z } from 'zod';

import { AD_TYPES } from '../../../../queries';

export const schemaAd = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'Nazwa jest wymagana')
    .max(120, 'Maksymalna liczba znaków to 120'),
  image: z.string().min(1, 'Dodaj grafikę reklamy'),
  type: z.enum(AD_TYPES),
  // Aplikacje sortują reklamy rosnąco po `order`, więc pole musi być liczbą —
  // input zwraca string, stąd `coerce`.
  order: z.coerce
    .number({ invalid_type_error: 'Kolejność musi być liczbą' })
    .int('Kolejność musi być liczbą całkowitą')
    .min(0, 'Kolejność nie może być ujemna'),
  url: z
    .string()
    .trim()
    .url('Podaj pełny adres, razem z https://')
    .or(z.literal('')),
  assigned_hotels: z.array(z.string()),
});

export type AdFormEntity = z.infer<typeof schemaAd>;

const adResolver: Resolver<AdFormEntity> = zodResolver(schemaAd) as never;

export const AdFormOptions: UseFormProps<AdFormEntity> = {
  mode: 'onSubmit',
  resolver: adResolver,
};
